import React from 'react'
import './CorrectionUpdates.css'


const CorrectionUpdates = () => {
  return (
    <div className='CorrectionUpdates'>
      <div className='EmptyRepo'>
        <h5>* But nobody came. No correction updates yet.</h5>
      </div>
      
    </div>
  )
}

export default CorrectionUpdates
